export const threeWayMerge = (local: any, saved: any, updated: any): any => {
  if (local == null || saved == null || updated == null) {
    // If local is now null but we last saved something not null, then we have deleted the local value, so it is meaningful.
    if (local == null) {
      if (saved == null) {
        return updated;
      }
      // this is a meaningful change, so use local
      return local;
    }

    if (local != saved) {
      return local;
    }

    return updated;
  }

  // Handle primitive values
  if (typeof local !== "object") {
    return local !== saved ? local : updated;
  }

  // Handle arrays
  if (Array.isArray(local)) {
    if (!Array.isArray(saved) || !Array.isArray(updated)) {
      return updated;
    }

    const maxLength = Math.max(local.length, saved.length, updated.length);
    const result = [];

    for (let i = 0; i < maxLength; i++) {
      if (i < local.length && i < saved.length && i < updated.length) {
        result.push(threeWayMerge(local[i], saved[i], updated[i]));
      } else if (i < local.length) {
        result.push(local[i]);
      } else if (i < updated.length) {
        result.push(updated[i]);
      }
    }

    return result;
  }

  // Handle objects - fully recursive approach
  const result: any = {};
  const allKeys = new Set([
    ...Object.keys(local || {}),
    ...Object.keys(saved || {}),
    ...Object.keys(updated || {}),
  ]);

  for (const key of allKeys) {
    const localVal = local?.[key];
    const savedVal = saved?.[key];
    const updatedVal = updated?.[key];

    result[key] = threeWayMerge(localVal, savedVal, updatedVal);
  }

  return result;
};

export default threeWayMerge;
